if (!window.customElements.get('bundle-quiz')) {
  window.customElements.define('bundle-quiz', class extends HTMLElement {
    connectedCallback() {
      this.config = this._parseConfig();
      this.legacyRules = this._parseRules('[data-quiz-rules]');
      this.text = JSON.parse(this.querySelector('[data-quiz-text]').textContent);
      this.answers = [null, null, null];
      this.stepIndex = 1;
      this.steps = Array.from(this.querySelectorAll('[data-quiz-step]'));
      this.bars = Array.from(this.querySelectorAll('[data-quiz-bar]'));

      this.addEventListener('click', this._onClick.bind(this));
      this._logConfig();
    }

    _parseConfig() {
      var config = { byQuestion: { 1: [], 2: [], 3: [] }, products: {}, occurrences: {} };
      try {
        var node = this.querySelector('[data-quiz-config]');
        var raw = node ? JSON.parse(node.textContent) : {};
        (raw.answers || []).forEach(function(answer) {
          answer.products = (answer.products || []).map(Number);
          (config.byQuestion[answer.q] = config.byQuestion[answer.q] || []).push(answer);
          answer.products.forEach(function(id) {
            config.occurrences[id] = (config.occurrences[id] || 0) + 1;
          });
        });
        (raw.products || []).forEach(function(product) {
          config.products[product.id] = product;
        });
      } catch (error) {
        console.warn('[bundle-quiz] Invalid quiz config JSON — falling back to spreadsheet rules.', error);
      }
      return config;
    }

    _parseRules(selector) {
      try {
        var node = this.querySelector(selector);
        if (!node) return [];
        var raw = JSON.parse(node.textContent);
        var rules = typeof raw === 'string' ? JSON.parse(raw) : raw;
        return Array.isArray(rules) ? rules : [];
      } catch (e) {
        console.warn('[bundle-quiz] Invalid fallback rules JSON.', e);
        return [];
      }
    }

    _logConfig() {
      var config = this.config;
      var assigned = Object.keys(config.products).length;
      var summary = [1, 2, 3].map(function(q) {
        return 'Q' + q + ': ' + config.byQuestion[q].length + ' answers';
      }).join(', ');
      console.debug('[bundle-quiz] Config loaded — ' + summary + '; ' + assigned +
        ' distinct products assigned; ' + this.legacyRules.length + ' spreadsheet fallback rules.');

      [1, 2, 3].forEach(function(q) {
        if (!config.byQuestion[q].length) {
          console.warn('[bundle-quiz] Question ' + q + ' has no answer blocks — the quiz cannot be completed.');
        }
        config.byQuestion[q].forEach(function(answer) {
          if (!answer.products.length) {
            console.debug('[bundle-quiz] Answer "' + answer.label + '" (Q' + q + ') has no products assigned — spreadsheet fallback will be used for it.');
          }
        });
      });
    }

    _onClick(event) {
      var answer = event.target.closest('[data-quiz-answer]');
      if (answer) return this._selectAnswer(answer);
      if (event.target.closest('[data-quiz-back]')) return this._goBack();
      var shop = event.target.closest('[data-quiz-result-link]');
      if (shop && this._quickViewUrl && this._openQuickView(this._quickViewUrl)) {
        event.preventDefault();
      }
    }

    /* Open the result product in the theme's quick view (drawer on desktop,
       popover on mobile) instead of navigating. Returns false when the
       quick-view containers are unavailable, letting the link navigate. */
    _openQuickView(productUrl) {
      var isPhone = window.matchMedia('(max-width: 740px)').matches;
      var element = this.querySelector(isPhone ? '[data-quiz-quick-popover]' : '[data-quiz-quick-drawer]');
      if (!element) return false;
      var view = isPhone ? 'quick-buy-popover' : 'quick-buy-drawer';
      var target = productUrl + (productUrl.indexOf('?') >= 0 ? '&' : '?') + 'view=' + view;
      if (element.getAttribute('data-quiz-loaded-url') !== target) {
        element.innerHTML = '';
        element.setAttribute('href', target);
        element.setAttribute('data-quiz-loaded-url', target);
      }
      console.debug('[bundle-quiz] Opening quick view:', target);
      element.open = true;
      return true;
    }

    /* Descriptions are trusted store content (the product's own
       description HTML), rendered with formatting. */
    _setResultDescription(html) {
      var el = this.querySelector('[data-quiz-result-description]');
      if (el) el.innerHTML = html || '';
    }

    _setResultImage(url, alt) {
      var mediaEl = this.querySelector('[data-quiz-result-media]');
      var imageEl = this.querySelector('[data-quiz-result-image]');
      if (!mediaEl || !imageEl) return;
      if (url) {
        imageEl.src = url;
        imageEl.alt = alt || '';
        mediaEl.hidden = false;
      } else {
        imageEl.removeAttribute('src');
        imageEl.alt = '';
        mediaEl.hidden = true;
      }
    }

    _selectAnswer(button) {
      var step = button.closest('[data-quiz-step]');
      var stepNumber = parseInt(step.getAttribute('data-quiz-step'), 10);
      this.answers[stepNumber - 1] = parseInt(button.getAttribute('data-quiz-answer'), 10);

      step.querySelectorAll('[data-quiz-answer]').forEach(function(b) {
        b.classList.toggle('is-selected', b === button);
      });
      this._updateProgress();
      console.debug('[bundle-quiz] Q' + stepNumber + ' answered: "' + button.textContent.trim() + '" (position ' + this.answers[stepNumber - 1] + ')');
      this._emit('bundle-quiz:answer', { question: stepNumber, answer: this.answers[stepNumber - 1] });

      clearTimeout(this._advanceTimer);
      this._advanceTimer = setTimeout(function() {
        if (stepNumber < 3) {
          this._showStep(stepNumber + 1);
        } else {
          this._showResult();
        }
      }.bind(this), 300);
    }

    _goBack() {
      clearTimeout(this._advanceTimer);
      var target = this.stepIndex === 'result' ? 3 : Math.max(1, this.stepIndex - 1);
      this.answers[target - 1] = null;
      var step = this.steps.find(function(s) { return s.getAttribute('data-quiz-step') === String(target); });
      step.querySelectorAll('[data-quiz-answer]').forEach(function(b) { b.classList.remove('is-selected'); });
      this._showStep(target);
      this._updateProgress();
    }

    _showStep(number) {
      this.stepIndex = number;
      this.steps.forEach(function(s) {
        s.hidden = s.getAttribute('data-quiz-step') !== String(number);
      });
    }

    _updateProgress() {
      this.bars.forEach(function(bar, index) {
        bar.classList.toggle('is-done', this.answers[index] !== null);
      }.bind(this));
    }

    /*
      Recommendation logic ("bottleneck"): every product gets a score = in how
      many of the three chosen answers' lists it appears.
        1. score 3 (in all lists)      -> exact product match, wins.
        2. exact spreadsheet rule       -> transition fallback while bundles
                                           are not yet created/assigned.
        3. best partial score (2, 1)    -> closest product match.
        4. nothing                      -> fallback card.
      Ties: prefer a product matching the Goal answer, then the rarest one
      (assigned to the fewest answers overall = the most specific stack).
    */
    _resolve(a) {
      var config = this.config;
      var lists = [1, 2, 3].map(function(q) {
        var answer = config.byQuestion[q][a[q - 1] - 1];
        return (answer && answer.products) || [];
      });

      var scores = {};
      lists.forEach(function(list) {
        list.forEach(function(id) { scores[id] = (scores[id] || 0) + 1; });
      });
      var ids = Object.keys(scores).map(Number);
      var best = ids.reduce(function(max, id) { return Math.max(max, scores[id]); }, 0);

      var pickBest = function(score) {
        var candidates = ids.filter(function(id) { return scores[id] === score; });
        candidates.sort(function(x, y) {
          var goalX = lists[0].indexOf(x) === -1 ? 1 : 0;
          var goalY = lists[0].indexOf(y) === -1 ? 1 : 0;
          if (goalX !== goalY) return goalX - goalY;
          var rarity = (config.occurrences[x] || 0) - (config.occurrences[y] || 0);
          if (rarity !== 0) return rarity;
          return lists[0].indexOf(x) - lists[0].indexOf(y);
        });
        if (candidates.length > 1) {
          console.debug('[bundle-quiz] ' + candidates.length + ' products tied at score ' + score + '/3 — picked the most specific one.', candidates);
        }
        return candidates[0];
      };

      if (best === 3) {
        var winner = pickBest(3);
        console.debug('[bundle-quiz] Exact product match (all 3 answers):', config.products[winner].h);
        return { type: 'product', product: config.products[winner], score: 3 };
      }

      var rule = this.legacyRules.find(function(r) { return r.g === a[0] && r.e === a[1] && r.d === a[2]; });
      if (rule) {
        console.debug('[bundle-quiz] No exact product match (best overlap ' + best + '/3) — using spreadsheet rule:', rule.t);
        return { type: 'legacy', rule: rule };
      }

      if (best > 0) {
        var partial = pickBest(best);
        console.debug('[bundle-quiz] Partial product match (' + best + '/3 answers):', config.products[partial].h);
        return { type: 'product', product: config.products[partial], score: best };
      }

      console.debug('[bundle-quiz] No product overlap and no spreadsheet rule for answers [' + a.join(', ') + '] — showing fallback.');
      return { type: 'fallback' };
    }

    _showResult() {
      var a = this.answers;
      var result = this._resolve(a);
      var titleEl = this.querySelector('[data-quiz-result-title]');
      var itemsEl = this.querySelector('[data-quiz-result-items]');
      var pricesEl = this.querySelector('[data-quiz-result-prices]');
      var compareEl = this.querySelector('[data-quiz-result-compare]');
      var priceEl = this.querySelector('[data-quiz-result-price]');
      var linkEl = this.querySelector('[data-quiz-result-link]');
      var fallbackUrl = this.getAttribute('data-fallback-url') || '/collections/all';

      linkEl.textContent = this.text.shopLabel;
      this._quickViewUrl = null;
      this._setResultImage(null);
      this._setResultDescription('');

      if (result.type === 'product') {
        var product = result.product;
        this._quickViewUrl = product.u || null;
        this._setResultImage(product.img, product.t);
        this._setResultDescription(product.d);
        titleEl.textContent = product.t;
        this._renderComponents(itemsEl, product.c, product.i);
        if (product.p) {
          compareEl.textContent = this._money(product.cp);
          compareEl.hidden = !product.cp || product.cp <= product.p;
          priceEl.textContent = this._money(product.p);
          pricesEl.hidden = false;
        } else {
          pricesEl.hidden = true;
        }
        linkEl.href = product.u || fallbackUrl;
      } else if (result.type === 'legacy') {
        var rule = result.rule;
        titleEl.textContent = rule.t;
        this._renderComponents(itemsEl, rule.c, rule.i);
        if (rule.p) {
          compareEl.textContent = this._money(rule.cp);
          compareEl.hidden = !rule.cp || rule.cp <= rule.p;
          priceEl.textContent = this._money(rule.p);
          pricesEl.hidden = false;
        } else {
          pricesEl.hidden = true;
        }
        linkEl.href = rule.u || (rule.h ? '/products/' + rule.h : fallbackUrl);
        this._hydrateFromProduct(rule, titleEl, pricesEl, compareEl, priceEl, linkEl, fallbackUrl);
      } else {
        titleEl.textContent = this.text.fallbackTitle;
        itemsEl.textContent = this.text.fallbackItems;
        pricesEl.hidden = true;
        linkEl.href = fallbackUrl;
        linkEl.textContent = this.text.fallbackButton;
      }

      this.stepIndex = 'result';
      this.steps.forEach(function(s) {
        s.hidden = s.getAttribute('data-quiz-step') !== 'result';
      });
      var stack = result.type === 'product' ? result.product.t : (result.type === 'legacy' ? result.rule.t : null);
      var handle = result.type === 'product' ? result.product.h : (result.type === 'legacy' ? result.rule.h : null);
      this._emit('bundle-quiz:result', { answers: a.slice(), stack: stack, handle: handle, source: result.type });
    }

    /* Components line: each component links to its product page with a
       "Learn more" tooltip on hover. Falls back to plain text when the
       result has no component list. */
    _renderComponents(el, components, fallbackText) {
      el.textContent = '';
      /* Guard against non-string fallback data (e.g. raw object arrays). */
      if (Array.isArray(fallbackText)) {
        fallbackText = fallbackText.map(function(entry) {
          return entry && (entry.title || entry.n) || '';
        }).filter(Boolean).join(' + ');
      } else if (typeof fallbackText !== 'string') {
        fallbackText = '';
      }
      if ((!components || !components.length) && !fallbackText) {
        return;
      }
      var label = document.createElement('strong');
      label.className = 'bundle-quiz__includes-label';
      label.textContent = this.text.includesLabel;
      el.appendChild(label);
      el.appendChild(document.createTextNode(' '));
      if (!components || !components.length) {
        el.appendChild(document.createTextNode(fallbackText));
        return;
      }
      components.forEach(function(component, index) {
        if (index > 0) el.appendChild(document.createTextNode(' + '));
        var url = component.u || (component.h ? '/products/' + component.h : null);
        if (!url) {
          el.appendChild(document.createTextNode(component.n));
          return;
        }
        var link = document.createElement('a');
        link.className = 'bundle-quiz__component';
        link.href = url;
        link.target = '_blank';
        link.textContent = component.n;
        link.setAttribute('data-tip', this.text.learnMoreLabel);
        el.appendChild(link);
      }, this);
    }

    /* Legacy spreadsheet rule: when the bundle product already exists in the
       store under the rule's handle, prefer its live data. */
    _hydrateFromProduct(rule, titleEl, pricesEl, compareEl, priceEl, linkEl, fallbackUrl) {
      if (!rule.h) return;
      fetch('/products/' + rule.h + '.js')
        .then(function(response) {
          if (!response.ok) throw new Error('missing');
          return response.json();
        })
        .then(function(product) {
          titleEl.textContent = product.title;
          /* Match the storefront default: first available variant (product.price
             is price_min, which for multi-variant bundles is a cheap/unavailable
             combo and mispairs with compare_at_price). */
          var variant = (product.variants || []).filter(function(v) { return v.available; })[0] || (product.variants || [])[0] || product;
          priceEl.textContent = this._money(variant.price / 100);
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = this._money(variant.compare_at_price / 100);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
          pricesEl.hidden = false;
          /* Product exists — enable quick view, show its image and description. */
          this._quickViewUrl = '/products/' + rule.h;
          this._setResultImage(product.featured_image, product.title);
          this._setResultDescription(product.description || '');
        }.bind(this))
        .catch(function() {
          /* Bundle product not created yet — keep the spreadsheet data,
             but make sure the link doesn't 404. */
          console.debug('[bundle-quiz] Bundle product "/products/' + rule.h + '" not found — Shop button points to the fallback link.');
          linkEl.href = fallbackUrl;
        });
    }

    _money(value) {
      if (value == null || isNaN(value)) return '';
      return '$' + Number(value).toFixed(2);
    }

    _emit(name, detail) {
      document.dispatchEvent(new CustomEvent(name, { detail: detail }));
    }
  });
}
